import { useEffect, useState } from "react";

/**
 * Devuelve una versión diferida del valor. Útil para evitar que una
 * búsqueda dispare `useListXxxQuery` en cada keystroke — con 300 ms la
 * usuaria termina de tipear antes de hacer el request.
 *
 * No cancela el valor "pendiente" si cambia, simplemente resetea el
 * timer — el behavior esperado para search debounce.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
